import { api } from "assets/scripts/utilities/api-clients";

export const index = async (_id) => {
  const response = await api.get(`/kam/rfq/active-dealsubmission/${_id}`);

  return response;
};

export const get = async (_id) => {
  const response = await api.get(`/kam/deal/${_id}`);

  return response;
};

export const post = async (deal) => {
  const response = await api.post("/kam/deals", deal);

  return response;
};

export const put = async (user) => {
  const response = await api.put("/deal", user);

  return response;
};
